<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12" lg="12">
        <b-card header="Bounce Backs">
          <el-table :data="bounceTable.slice().reverse()">
            <el-table-column label="Candidate">
              <template slot-scope="scope">
                <router-link
                  :to="'/user/' + scope.row.general_id "
                >{{ scope.row.first_name + ' ' + scope.row.last_name }}</router-link>
              </template>
            </el-table-column>
            <el-table-column label="Event" width="240">
              <template slot-scope="scope">{{ scope.row.event_type }}</template>
            </el-table-column>
            <el-table-column label="Date" width="240">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px">{{ formatDate(scope.row.created_at) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from '../../shared/axios';
import { setTimeout } from 'timers';
import { unserialize } from '../../shared/unserialize.js';
import moment from 'moment';

export default {
  data() {
    return {
      bounceTable: []
    };
  },
  async created() {
    const bounces = await axios.get('email/bounces');
    console.log(bounces.data);
    this.bounceTable = bounces.data;
  },
  methods: {
    formatDate(input) {
      return moment(input).format('M/D/YYYY h:mm a z');
    }
  }
};
</script>
